var map = {
	"./music-instructions.json": 4710,
	"./music-library-intro2024.json": 4711,
	"./music-library-launch2024.json": 4712,
	"./music-progression.json": 4713,
	"./startSourcesAdvanced.json": 4714,
	"./startSourcesSimple.json": 4715,
	"./startSourcesSimple2.json": 4716,
	"./startSourcesTracks.json": 4717
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4478;